$('.supportFeed').slick({
    slidesToShow: 9,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [

     
     {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
         
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
         
        }
      },
      {
        breakpoint: 768,
        settings: {
         slidesToShow: 3,
         slidesToScroll: 3,
       }
       
      },
      {
        breakpoint: 480,
        settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
       }
       
      },
      {
        breakpoint: 330,
        settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
       }
       
      }
      
    ]        
});
